import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { REGISTRATION_WITH_SPID_ID_ACTION_TYPE } from "./registration-with-spid.action";
import { RegistrationWithSPIDState } from "./registration-with-spid.model";

const INITIAL_STATE: RegistrationWithSPIDState = {
	getSPIDAuthorizationUrlSuccess: undefined,
	spIdAuthorizationUrl: undefined,

	getSPIDJwtTokenSuccess: undefined,
	spIdJwtToken: undefined,

	getRegistrationTokenSuccess: undefined,
	registrationToken: undefined,
};

export function registrationWithSPIDReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): RegistrationWithSPIDState {
	switch (action.type) {
		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDAuthorizationUrl: {
			return updateState(state, {
				getSPIDAuthorizationUrlSuccess: undefined,
				spIdAuthorizationUrl: undefined,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDAuthorizationUrlSuccess: {
			return updateState(state, {
				getSPIDAuthorizationUrlSuccess: true,
				spIdAuthorizationUrl: action.payload,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDAuthorizationUrlFail: {
			return updateState(state, {
				getSPIDAuthorizationUrlSuccess: false,
				spIdAuthorizationUrl: undefined,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDJwtToken: {
			return updateState(state, {
				getSPIDJwtTokenSuccess: undefined,
				spIdJwtToken: undefined,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDJwtTokenSuccess: {
			return updateState(state, {
				getSPIDJwtTokenSuccess: true,
				spIdJwtToken: action.payload,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getSPIDJwtTokenFail: {
			return updateState(state, {
				getSPIDJwtTokenSuccess: false,
				spIdJwtToken: undefined,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getRegistrationToken: {
			return updateState(state, {
				getRegistrationTokenSuccess: undefined,
				registrationToken: undefined,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getRegistrationTokenSuccess: {
			return updateState(state, {
				getRegistrationTokenSuccess: true,
				registrationToken: action.payload,
			});
		}

		case REGISTRATION_WITH_SPID_ID_ACTION_TYPE.getRegistrationTokenFail: {
			return updateState(state, {
				getRegistrationTokenSuccess: false,
				registrationToken: undefined,
			});
		}

		default:
			return state;
	}
}
